import React from "react";
import { Question, Questionnaire } from "./models";
import MultipleChoiseView from "./MultipleChoiseView";
import MultipleChoiceMultiSelectView from "./MultipleChoiceMultiSelectView";
import InputTextView from "./InputTextView";
import InputDateView from "./InputDateView";
import QuestionLabelView from "./QuestionLabelView";
import InputNumberView from "./InputNumberView";
import InputHeightView from "./InputHeightView";
import InputWeightView from "./InputWeightView";

export const QuestionView = ({question, questionnaire, onChange} : { question : Question, questionnaire: Questionnaire, onChange: (question: Question) => void }) => {

  return (
    <div>
      {question.type === 'multiple-choice' && (
        <MultipleChoiseView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
      {question.type === 'multiple-choice-multi-select' && (
        <MultipleChoiceMultiSelectView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
      {question.type === 'text' && (
        <InputTextView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
      {question.type === 'integer' && (
        <InputNumberView question={question} questionnaire={questionnaire} onChange={onChange} pattern="^[0-9]*$"/>
      )}
      {question.type === 'float' && (
        <InputNumberView question={question} questionnaire={questionnaire} onChange={onChange} pattern="^[0-9]*\.?[0-9]{0,2}$"/>
      )}
      {question.type === 'number' && (
        <InputNumberView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
      {question.type === 'date' && (
        <InputDateView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
      {question.type === 'question-label' && (
        <QuestionLabelView question={question} questionnaire={questionnaire} />
      )}
      {question.type === 'height' && (
        <InputHeightView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
      {question.type === 'weight' && (
        <InputWeightView question={question} questionnaire={questionnaire} onChange={onChange} />
      )}
    </div>
  );
}
